<template>
	<div>
		<v-toolbar dense dark color="#f0f0f0" elevation="0">
			<v-spacer />
			<v-btn @click="openMailDialog()" color="black" text class="mr-2 print-btn"
				><v-icon class="mr-1">mdi-send</v-icon>メール送信</v-btn
			>
			<v-btn class="ml-2 print-btn" text color="black" @click="handlePrint()">
				<v-icon class="mr-1">mdi-printer-outline</v-icon>
				印刷</v-btn
			>
		</v-toolbar>

		<div class="sheets mt-4" id="sheets">
			<div class="print-sheet" id="print" ref="print">
				<v-hover close-delay="200" open-delay="200">
					<div class="sheet">
						<div class="text-center color-text text-h5 font-weight-bold">注　文　書</div>
						<v-row no-gutters class="mt-4">
							<v-col cols="1" />
							<v-col cols="4">
								<div class="mt-4 d-flex justify-space-between">
									<div class="serif">
										{{ supplier.name }}
									</div>
									<div class="serif">御中</div>
								</div>
								<div class="d-flex bottom-border">
									<div class="mt-13 mr-5">合計金額</div>
									<div class="mt-10 text-h6">{{ order_data.grand_total }}円　(税込)</div>
								</div>
							</v-col>
							<v-col cols="2" />
							<v-col cols="4">
								<div class="serif">
									極東ゴム株式会社
									<br />
									<br />
									590-0904
									<br />
									大阪府堺市堺区南島町4丁17番地
									<br />
									TEL：072-232-0465（代表）
									<br />
									FAX：072-232-1896
								</div>
							</v-col>
							<v-col cols="1"></v-col>
						</v-row>

						<v-row no-gutters class="mt-2" justify="space-between">
							<v-col cols="6" />
							<v-col class="color-table-wrapper">
								<table class="mt-2" width="100%">
									<tbody>
										<tr>
											<th class="th font-xs right-border text-center">注文書番号</th>
											<th class="th font-xs right-border text-center">担当</th>
										</tr>
									</tbody>
									<tbody>
										<tr>
											<EditableCell
												:editable="editable"
												:paragraphStyle="style.serif"
												:componentStyle="style.borderRight"
												:value="order_data.order_number"
												@update-value="order_data.order_number = $event"
											/>

											<EditableCell
												:editable="editable"
												:paragraphStyle="style.serif"
												:componentStyle="style.borderRight"
												:value="current_user.last_name"
												@update-value="current_user.last_name = $event"
											/>
										</tr>
									</tbody>
								</table>
							</v-col>
						</v-row>
						<div class="color-table-wrapper mt-2">
							<table width="100%">
								<thead>
									<tr>
										<th rowspan="3" class="text-center right-border" width="6%">No.</th>
										<th
											rowspan="2"
											colspan="3"
											class="text-center right-border bottom-border"
											width="54%"
										>
											部　品　名
										</th>
										<th rowspan="" class="right-border bottom-border" width="12%"></th>
										<th rowspan="3" class="text-center right-border" width="4%">単位</th>
										<th
											rowspan=""
											class="text-center right-border bottom-border font-xs"
											width="12%"
										>
											単　価
										</th>
										<th rowspan="3" class="text-center" width="12%">摘　要</th>
									</tr>
									<tr>
										<th class="text-center right-border bottom-border font-xs">数　量</th>
										<th rowspan="2" class="text-center right-border">金　額</th>
									</tr>
									<tr>
										<th class="text-center right-border font-xs" width="18%">納期希望</th>
										<th class="right-border" width="18%"></th>
										<th class="right-border"></th>
									</tr>
								</thead>
								<v-hover
									v-for="(order_data_component, index) in order_data_components"
									:key="`order_data_component-${order_data_component.id}`"
									class="bottom-border"
									v-slot="{ hover }"
									close-delay="200"
									open-delay="200"
								>
									<tbody>
										<v-btn
											v-if="editable"
											v-show="hover"
											class="hide-print delete-btn"
											color="red"
											fab
											x-small
											dark
											outlined
											absolute
											@click="removeOrderDataComponent(order_data_component.id)"
											><v-icon dark>mdi-close</v-icon></v-btn
										>
										<tr>
											<td
												:editable="editable"
												:rowspan="3"
												:paragraphStyle="style.serif"
												:componentStyle="{ ...style.borderRight, ...style.textCenter }"
												style="border-right: 0.5px solid rgb(110, 52, 52)"
											>
												{{ index + 1 }}
											</td>
											<EditableCell
												:editable="editable"
												:rowspan="2"
												:colspan="3"
												:paragraphStyle="style.serif"
												:componentStyle="setStyle(['verticalTop', 'borderBottom', 'fontXs'])"
												:value="order_data_component.component_name"
												text
												@update-value="order_data_component.component_name = $event"
												style="border-right: 0.5px solid rgb(110, 52, 52)"
											/>
											<td rowspan="" class="right-border bottom-border"></td>
											<EditableCell
												:editable="editable"
												:rowspan="3"
												:paragraphStyle="style.serif"
												:componentStyle="setStyle(['borderRight'])"
												:value="order_data_component.unit"
												@update-value="order_data_component.unit = $event"
												style="border-left: 0.5px solid rgb(110, 52, 52)"
											/>
											<EditableCell
												:editable="false"
												:paragraphStyle="style.serif"
												:componentStyle="setStyle(['borderRight', 'textRight', 'borderBottom'])"
												:value="
													order_data_component.unit_price
														? order_data_component.unit_price.toLocaleString()
														: ''
												"
												@update-value="order_data_component.unit_price = $event"
											/>
											<EditableCell
												:editable="editable"
												:rowspan="3"
												:paragraphStyle="style.serif"
												:componentStyle="setStyle(['fontXs', 'verticalTop'])"
												:value="order_data_component.remarks"
												@update-value="order_data_component.remarks = $event"
											/>
										</tr>
										<tr>
											<EditableCell
												:editable="false"
												:paragraphStyle="style.serif"
												:componentStyle="setStyle(['borderRight', 'textRight', 'borderBottom'])"
												:value="order_data_component.quantity"
												@update-value="order_data_component.quantity = $event"
											/>
											<EditableCell
												:editable="false"
												:rowspan="2"
												:paragraphStyle="style.serif"
												:componentStyle="
													setStyle(['borderRight', 'textRight', 'borderBottom', 'verticalBottom'])
												"
												:value="
													order_data_component.subtotal
														? order_data_component.subtotal.toLocaleString()
														: ''
												"
												@update-value="order_data_component.subtotal = $event"
											/>
										</tr>
										<tr>
											<EditableCell
												:editable="editable"
												:rowspan="2"
												:paragraphStyle="style.serif"
												:componentStyle="setStyle(['borderRight', 'fontXs'])"
												:value="order_data_component.expected_receiving_date | dateFormatter"
												@update-value="order_data_component.expected_receiving_date = $event"
											/>
											<td class="right-border"></td>
											<td class="right-border"></td>
										</tr>
									</tbody>
								</v-hover>
								<template>
									<tbody class="bottom-border">
										<tr>
											<td rowspan="3" class="text-center right-border"><br /></td>
											<td
												rowspan="2"
												colspan="3"
												class="vertical-top right-border bottom-border font-xs"
											>
												<br />
											</td>
											<td rowspan="" class="right-border bottom-border"><br /></td>
											<td rowspan="3" class="right-border"><br /></td>
											<td rowspan="" class="text-right right-border bottom-border"><br /></td>
											<td rowspan="3"><br /></td>
										</tr>
										<tr>
											<td class="text-right right-border bottom-border"><br /></td>
											<td rowspan="2" class="text-right right-border bottom-border vertical-bottom">
												<br />
											</td>
										</tr>
										<tr>
											<td class="right-border font-xs"><br /></td>
											<td class="right-border font-xs"><br /></td>
											<td class="right-border"><br /></td>
											<td class="right-border"><br /></td>
										</tr>
									</tbody>
								</template>
							</table>
							<table class="no-top-border" width="88.05%">
								<tbody>
									<tr>
										<th class="text-body-2 font-wight-bold text-center" width="7%">備考</th>
										<EditableCell
											:editable="editable"
											:paragraphStyle="style.serif"
											:value="order_data.other"
											@update-value="order_data.other = $event"
										/>
										<th class="px-1 font-xs line-height-narrow text-center" width="3%">
											対<br />象<br />額
										</th>
										<EditableCell
											:editable="false"
											:paragraphStyle="style.serif"
											:width="'14%'"
											:componentStyle="setStyle(['verticalBottom', 'textRight'])"
											:value="order_data.total_price ? order_data.total_price.toLocaleString() : ''"
											@update-value="order_data.total_price = $event"
										/>
										<th class="px-1 font-xs line-height-narrow text-center" width="3%">
											消<br />費<br />税
										</th>
										<EditableCell
											:editable="false"
											:paragraphStyle="style.serif"
											:width="'14%'"
											:value="order_data.tax"
											:componentStyle="setStyle(['verticalBottom', 'textRight'])"
											@update-value="order_data.tax = $event"
										/>
										<th class="px-1 font-xs line-height-narrow text-center" width="3%">
											合<br />計
										</th>
										<EditableCell
											:editable="false"
											:paragraphStyle="style.serif"
											:width="'14%'"
											:value="order_data.grand_total"
											:componentStyle="setStyle(['verticalBottom', 'textRight'])"
											@update-value="order_data.grand_total = $event"
										/>
									</tr>
								</tbody>
							</table>
						</div>
						<MailDialog
							:dialog.sync="dialog"
							:orderDataId="order_data.id"
							:orderData="order_data"
							:orderDataComponents="order_data_components"
							:currentUser="current_user"
							:supplier="supplier"
							:supplierEmails="supplierEmails"
							:ccEmails="ccEmails"
							v-if="isFetched"
						/>
					</div>
				</v-hover>
			</div>
		</div>
	</div>
</template>

<script>
import MailDialog from "./component/MailDialog.vue"
import EditableCell from "../printed_matter/components/EditableCell.vue"
import common from "../../helper/common"
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"
import moment from "moment"
import "moment/locale/ja"

export default {
	filters: {
		dateFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("YYYY/MM/DD(dd)")
		},
		formatNumber(value) {
			return value.toLocaleString()
		},
	},
	components: {
		MailDialog,
		EditableCell,
	},
	data() {
		return {
			dialog: false,
			component_name: "",
			date: "",
			unit_price: "",
			quantity: "",
			remarks: "",
			supplierName: "",
			supplierPerson: "",
			supplierEmail: "",
			supplierId: "",
			current_user: {},
			order_component_id: "",
			rules,
			common,
			style: initialStyle(),
			showDialog: true,
			loading: false,
			order_data_id: this.$route.params["id"],
			order_data_components: [],
			supplier: {},
			order_data: [],
			editable: true,
			order_components: [],
			isFetched: false,
			supplierEmails: [],
			ccEmails: [],
		}
	},

	mounted() {
		this.fetchOrderDataComponents()
	},
	methods: {
		sendOrderDataMail() {
			this.$refs.confirmation.openDialog()
		},
		onlyCreateOrderData() {
			const dialogTitle = this.onlyCreateOrderDialogTitle
			const dialogContent = this.onlyCreateOrderDialogContent
			const flag = "only_create"
			this.$refs.draft.openDialog(dialogTitle, dialogContent, flag)
		},

		openMailDialog() {
			this.dialog = true
		},

		fetchOrderDataComponents() {
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/order_data/preview/${this.order_data_id}`, { headers })
				.then((res) => {
					this.order_data = res.data.order_data
					this.order_data = {
						...this.order_data,
						other: "",
						tax: this.calculateTax(this.order_data.total_price)?.toLocaleString(),
						grand_total: (
							this.order_data.total_price + this.calculateTax(this.order_data.total_price)
						)?.toLocaleString(),
					}
					this.order_data_components = res.data.order_data.order_data_components
					this.order_data_components = this.order_data_components.map((component) => ({
						...component,
						unit: "個",
						subtotal: component.unit_price * component.quantity,
					}))
					this.current_user = res.data.current_user
					this.supplier = res.data.order_data.supplier
					this.isFetched = true
				})

				.catch((err) => {
					console.log(err)
				})
		},

		removeOrderDataComponent(order_data_component_id) {
			const order_data_component = this.order_data_components.find(
				(component) => component.id === order_data_component_id
			)
			const index = this.order_data_components.indexOf(order_data_component)
			this.order_data_components.splice(index, 1)
		},

		handlePrint() {
			document.title = ` ${this.order_data.order_date} 注文書 ${this.supplier.name} `

			var area = document.getElementById("sheets")
			var htmlDoc = document.body.innerHTML
			document.body.innerHTML = area.innerHTML
			window.print()
			document.body.innerHTML = htmlDoc
			this.$router.go({ path: this.$router.currentRoute.path, force: true })
		},

		calculateTax(total_price) {
			return Math.floor(total_price * 0.1)
		},

		setStyle(styles) {
			let style = {}
			styles.forEach((c) => (style = { ...style, ...this.style[c] }))
			return style
		},
	},
}
function initialStyle() {
	return {
		serif: { fontFamily: "serif, san-serif" },
		borderRight: { borderRight: ".5px solid rgb(110, 52, 52)" },
		borderBottom: { borderBottom: ".5px solid rgb(110, 52, 52)" },
		fontXs: { fontSize: "x-small" },
		textCenter: { textAlign: "center" },
		textRight: { textAlign: "right" },
		verticalTop: { verticalAlign: "top" },
		verticalBottom: { verticalAlign: "bottom" },
	}
}
</script>

<style scoped lang="scss">
@import "../../stylesheet/pdf/paper.scss";

$color: rgb(110, 52, 52);

.sheets {
	* {
		font-weight: light;
		font-size: 0.75rem;
	}
}
.serif {
	font-family: serif, sans-serif;
}
.color-text {
	color: $color;
}
.right-border {
	border-right: 0.5px solid;
}
.left-border {
	border-left: 0.5px solid;
}
.bottom-border {
	border-bottom: 0.5px solid;
	border-color: $color;
}
.no-top-border {
	border-top: 0px solid transparent !important;
}
.text-center {
	text-align: center;
}
.d-flex {
	display: flex;
}
.px-1 {
	padding: 0 4px;
}
.mt-4 {
	margin-top: 1rem;
}
.mt-2 {
	margin-top: 0.5rem;
}
.text-right {
	text-align: right;
}
.text-h5 {
	line-height: 2rem;
	font-family: Roboto, sans-serif !important;
	font-size: 1.5rem !important;
	letter-spacing: normal !important;
}
.font-weight-bold {
	font-weight: 700 !important;
}
.row {
	display: flex;
	flex-wrap: wrap;
	flex: 1 1 auto;
}
.text-justify {
	padding: 0 4px;
	text-align: justify;
	text-align-last: justify;
}
.justify-space-between {
	justify-content: space-between !important;
}
.font-xs {
	font-size: x-small;
}
.vertical-bottom {
	vertical-align: bottom;
}
.vertical-top {
	vertical-align: top;
}
.line-height-narrow {
	line-height: 1.1;
}
.delete-btn {
	right: -2rem;
	top: 0;
	bottom: 0;
}
.delete-page-btn {
	top: 0;
	right: 0;
}

.color-table-wrapper {
	table {
		border: 0.5px solid $color;
	}
	tbody {
		position: relative;
	}
	th,
	td.bg-color {
		background-color: $color !important;
		color: white;
		border-color: white;
	}
	td {
		font-family: serif, sans-serif;
		border-color: $color;
		padding: 0 4px;
		position: relative;
	}
	tr {
		border-color: $color;
	}
}

.print-sheet {
	page-break-after: always;
}

/* hide in print */
@media print {
	#app > :not(.print-sheet) {
		display: none;
	}
	.hide-print {
		display: none;
	}
	body {
		-webkit-print-color-adjust: exact;
	}
}

/* for preview */
@media screen {
	/* mm単位で指定しているけど、vueコンポ側はpx単位なので、無理にmmにしなくてもいいかも。解像度の違いでハマるかも */
	.sheet {
		width: 210mm;
		min-height: 296mm; /* 設定しなくてもいいかも。あまり印刷画面に似せすぎると、些細な違いがバグに見えてしまう */
		margin: 1rem auto;
		padding: 5mm;
		background: white;
		box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3);
	}
}
body {
	-webkit-print-color-adjust: exact;
}

@media print {
	.print-btn {
		display: none;
	}
}
</style>
